/**
 * Phase 1A · Shared effective-payment-method helper.
 *
 * Priority (docs/policy — do NOT reorder):
 *   1. payment.payment_method_actual   → authoritative actual method
 *   2. payment.method                   → canonical current method
 *   3. payment.payment_method_original  → HISTORICAL ONLY, never actual
 *
 * Used by every admin order-detail view that renders payment state:
 *   - Zelle Payment Verification card visibility
 *   - Payment Verified summary
 *   - Payment method badge
 *   - Record / Verify Payment initial method
 */
export const CANONICAL_METHODS = ["cash", "card", "cashapp", "zelle", "ebay", "other"];

export function getEffectivePaymentMethod(payment) {
  const p = payment || {};
  const actual = String(p.payment_method_actual || "").trim().toLowerCase();
  if (actual) return actual;
  const method = String(p.method || "").trim().toLowerCase();
  if (method) return method;
  return "";
}

export function isPaymentVerified(payment) {
  return !!(payment && payment.verified_at);
}

export function shouldShowZelleReconciliation(payment) {
  return getEffectivePaymentMethod(payment) === "zelle" && !isPaymentVerified(payment);
}

export const METHOD_LABELS = {
  cash: "Cash", card: "Card — In Store", cashapp: "Cash App",
  zelle: "Zelle", ebay: "eBay", other: "Other",
};
